import { useMemo } from "react";
import { useParams } from "react-router-dom";

import { type AbsoluteRoute, type RouteParams } from "../../core/routes";
import { MyLensesAssetType } from "../../gql-generated/types";
import { type GetOrganicStatsQueryVariables } from "../api/queries";

import { useLensIdSearchParameter } from "./useLensIdSearchParameter";

export const useLensBreakdownAssetQueryParams = (): Pick<
    GetOrganicStatsQueryVariables,
    "breakdownAssetType" | "lensId"
> => {
    const { lensId: lensIdSearch } = useLensIdSearchParameter();
    const { lensId: lensIdUrlParams } = useParams<RouteParams[AbsoluteRoute.LENS]>();

    const lensId = lensIdSearch ?? lensIdUrlParams;

    return useMemo(() => {
        if (lensId) {
            return {
                breakdownAssetType: MyLensesAssetType.Lens,
                lensId,
            };
        }

        return {
            breakdownAssetType: MyLensesAssetType.AssetTypeUnset,
            lensId: null,
        };
    }, [lensId]);
};
